import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faFilter, faUser, faUsers, faHashtag } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../contexts/AuthContext";
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * Component for handling song filtering, searching, and owner selection
 */
const SongFilterBar = ({
  selectedOwner,
  onOwnerChange,
  searchTerm,
  setSearchTerm,
  categoryFilter,
  setCategoryFilter,
  categories = [],
  availableTags = [],
  tagFilter,
  setTagFilter,
  getSongCountByOwnership,
}) => {
  const { t } = useLanguage();
  // Access user communities from auth context
  const { userCommunities, user } = useAuth();

  return (
    <div className="mb-4">
      {/* Search and filter row */}
      <div className="row">
        {/* Owner selection dropdown */}
        <div className="col-md-3 mb-3 mb-md-0">
          <InputGroup>
            <InputGroup.Text>
              <FontAwesomeIcon icon={selectedOwner === 'user' ? faUser : faUsers} />
            </InputGroup.Text>
            <Form.Select
              value={selectedOwner}
              onChange={(e) => onOwnerChange(e.target.value)}
            >
              <option value="user">My Personal Songs</option>
              {/* Map user's communities */}
              {userCommunities && userCommunities.map(community => (
                <option key={community.id} value={`community-${community.id}`}>
                  {community.name}
                </option>
              ))}
            </Form.Select>
          </InputGroup>
        </div>

        {/* Search field */}
        <div className="col-md-3 mb-3 mb-md-0">
          <InputGroup>
            <InputGroup.Text>
              <FontAwesomeIcon icon={faSearch} />
            </InputGroup.Text>
            <Form.Control
              type="text"
              placeholder="Search songs..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </InputGroup>
        </div>

        {/* Category filter */}
        <div className="col-md-3 mb-3 mb-md-0">
          <InputGroup>
            <InputGroup.Text>
              <FontAwesomeIcon icon={faFilter} />
            </InputGroup.Text>
            <Form.Select
              value={categoryFilter}
              onChange={(e) => setCategoryFilter(e.target.value)}
            >
              <option value="Vse">All categories</option>
              {categories.map(category => (
                <option key={category} value={category}>{category}</option>
              ))}
            </Form.Select>
          </InputGroup>
        </div>

        {/* Tag filter */}
        <div className="col-md-3">
          <InputGroup>
            <InputGroup.Text>
              <FontAwesomeIcon icon={faHashtag} />
            </InputGroup.Text>
            <Form.Select
              value={tagFilter}
              onChange={(e) => setTagFilter(e.target.value)}
            >
              <option value="Vse">{t('songbook.filter.allTags')}</option>
              {availableTags.map(tag => (
                <option key={tag} value={tag}>#{tag}</option>
              ))}
            </Form.Select>
          </InputGroup>
        </div>
      </div>
    </div>
  );
};

export default SongFilterBar;
